// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// router的配置
import './permission'
// 引入element-ui插件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.ignoredElements = ['wx-open-launch-weapp']

// swiper的css
// import 'swiper/dist/css/swiper.css'
// 引入vuex配置
import store from './store'
// 全局引入工具类
import Utils from '@/utils/utils.js'
// 全局常量
import Constant from '@/api/constant.js'
// ajax
import request from '@/utils/request'

// Vant-UI
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import VueBus from 'vue-bus'; 
Vue.use(VueBus);

import Router from 'vue-router'
 
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//filters
import filters from './utils/globalFilters' 
// import Breadcrumb from '@/components/commonBreadcrumb'
/* 全局注册过滤器 */
Object.keys(filters).forEach(item => Vue.filter(item,filters[item]))

Vue.config.productionTip = false
Vue.use(ElementUI)

// Vue.use(Breadcrumb)

Vue.prototype.$utils = Utils
Vue.prototype.$axios = request
Vue.prototype.$constant = Constant

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js